import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './register.module.css'

const baseURL = `${process.env.REACT_APP_API_URL}`

const Register = () => {

    const [formData , setFormData] = useState({
        email: '',
        first_name: '',
        last_name: '',
        username: '',
        password: '',
        password2: '',
        user_type: ''
    })
    const [message, setMessage] = useState('')
    const navigate = useNavigate()

    const handleRegChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value})
    }

    const handleRegSubmit = (e) => {
        e.preventDefault();
    
        if (formData.password !== formData.password2) {
            setMessage("Passwords must match");
            return;
        }
    
        fetch(`${baseURL}/accounts/registration/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(res => {
                if(!res.ok) {
                    return res.json().then(data => {
                        throw data
                    })
                }
                return res.json();
            })
            .then(data => {
                    setMessage(data.message);
                    setTimeout(() => {
                        navigate('/login')
                    }, 3000)
                
            })
            .catch(err => {
                if (err.email || err.username || err.password) {
                    // Handle specific error messages
                    const errorMessages = [];
                    if (err.email) errorMessages.push(err.email[0]);
                    if (err.username) errorMessages.push(err.username[0]);
                    if (err.password) errorMessages.push(err.password[0]);
                    setMessage(errorMessages.join(" , "));
                } else {
                    setMessage("An error occurred. Please try again.");
                }
                
            });
    };
    

    return (
        <div className={styles.regContainer}>
            <h2 className={styles.regH2}>Register An Account</h2>
            {message && <p className={styles.regMessage}>{message}</p>}
            <form onSubmit={handleRegSubmit}>
                <label>
                    Email:
                    <input type="email" name="email" value={formData.email} onChange={handleRegChange} required />
                </label>
                <label>
                    First Name:
                    <input type="text" name="first_name" value={formData.first_name} onChange={handleRegChange} required />
                </label>
                <label>
                    Last Name:
                    <input type="text" name="last_name" value={formData.last_name} onChange={handleRegChange} required />
                </label>
                <label>
                    Username:
                    <input type="text" name="username" value={formData.username} onChange={handleRegChange} required />
                </label>
                <label>
                    Password:
                    <input type="password" name="password" value={formData.password} onChange={handleRegChange} required />
                </label>
                <label>
                    Confirm Password:
                    <input type="password" name="password2" value={formData.password2} onChange={handleRegChange} required />
                </label>
                <label>
                    <select id='user_type' name='user_type' onChange={handleRegChange} value={formData.user_type}>
                        <option value="">Select User Type</option>
                        <option value="employer">Employer</option>
                        <option value="house_manager">House Manager</option>
                        <option value="school">School</option>
                    </select>
                </label>
                <button type='submit'>Register</button>
            </form>
        </div>
    )
}

export default Register; 